export default __webpack_public_path__ + "static/media/Chloe 9781843629566.b41dbd8f.jpg";